<script setup>

</script>

<template>
  <div class="flex flex-col items-center justify-center py-12 text-neutral-500 dark:text-neutral-400">
    <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6612 7H18.9999C20.1045 7 20.9999 7.89543 20.9999 9V18C20.9999 19.1046 20.1045 20 18.9999 20H5C3.89543 20 3 19.1046 3 18V7M11.6612 7C11.1745 7 10.7045 6.82252 10.3392 6.50083L8.06671 4.49917C7.70148 4.17748 7.23147 4 6.74477 4H5C3.89543 4 3 4.89543 3 6V7M11.6612 7H3" stroke="#020618" stroke-width="0.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <p class="text-lg" style="color: #020618">Нет данных</p>
  </div>
</template>

<style scoped>

</style>
